export const formErrorData = {
    formErrorMessages : {}
};

export const formErrorComputed = {
    allFormErrors() {
        return this.formErrorMessages;
    },
}

export const formErrorMethods = {
    clearAllErrors() {
        this.formErrorMessages = {};
    },
    hasErrors( key ) {
        return this.formErrorMessages.hasOwnProperty(key) && this.formErrorMessages[key].length;
    },
    getErrors( key ) {
        return this.formErrorMessages[key] || [];
    },
    addError( key, error ) {
        // Reassign rather than mutate for reactive watching
        this.formErrorMessages = {
            ...this.formErrorMessages,
            [key]: [ ...(this.formErrorMessages[key] || []), error ]
        };
    },
    clearErrors( key ) {
        // Reassign rather than mutate for reactive watching
        this.formErrorMessages = {
            ...this.formErrorMessages,
            [key]: []
        };
    },
    setErrors( key, errors ) {
        // Reassign rather than mutate for reactive watching
        this.formErrorMessages = {
            ...this.formErrorMessages,
            [key]: errors
        };
    },
    mapErrors( errors ) {
        for( let key in errors ) {
            if( errors.hasOwnProperty(key) && errors[key] instanceof Array )
                this.setErrors( key, errors[key] );
        }
    }
};

